import { Box, Heading, Text } from '@chakra-ui/react'

export const Experience = () => {
  return (
    <Box p={4}>
      <Heading mb={4}>Experience</Heading>
      <Text>Experience page coming soon...</Text>
    </Box>
  )
} 